import { Toaster as Sonner, type ToasterProps } from 'sonner'

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      closeButton
      richColors={false}
      toastOptions={{
        classNames: {
          toast:
            'group bg-popover text-popover-foreground border-border shadow-lg rounded-lg text-sm',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
          error: 'border-destructive/40 [&_[data-icon]]:text-destructive',
          success: 'border-success/40 [&_[data-icon]]:text-success',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
